/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useState } from 'react';

import { jsx } from '@compiled/react';
import Lottie from 'lottie-react';

import { cssMap } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

import rovoGlowBlobs from './assets/rovo-glow-blobs.json';

const styles = cssMap({
	glowOverlay: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '48px',
		height: '48px',
		borderRadius: token('radius.xxlarge'),
		overflow: 'hidden',
		pointerEvents: 'none',
		zIndex: 1,
		'@media (prefers-reduced-motion: reduce)': {
			display: 'none',
		},
	},
});

export function GlowAnimation(): JSX.Element | null {
	const [visible, setVisible] = useState(true);

	if (!visible) {
		return null;
	}

	return (
		// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic opacity not expressible as a design token
		<div css={styles.glowOverlay} style={{ opacity: 0.6 }} aria-hidden="true">
			<Lottie animationData={rovoGlowBlobs} loop={false} onComplete={() => setVisible(false)} />
		</div>
	);
}
